import React, { FC, useContext, useEffect, useState } from "react";
import { Navigate, Route, Routes, Outlet, useLocation } from "react-router-dom";
import { authRoutes, publicRoutes } from "./routes";
import { observer } from "mobx-react-lite";
import { Context } from "../..";
import { ACCOUNT_ROUTE, REGISTER_ROUTE_WITH_REF } from "../utils/consts";
import { check, fetchUserInfo } from "../http/userAPI";
import MyBigSpinner from "../components/UI/MyBigSpinner/MyBigSpinner";
import ScrollToTop from "../components/ScrollToTop/ScrollToTop";

const ProtectedRoute: FC = () => {
  const { user } = useContext(Context);
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();
  const isLocalProfilePreview =
    ["localhost", "127.0.0.1"].includes(window.location.hostname) &&
    location.pathname === "/profile";

  useEffect(() => {
    if (isLocalProfilePreview) {
      setIsAuthenticated(true);
      setIsLoading(false);
      return;
    }
    const verifyAuth = async () => {
      try {
        const authStatus = await check();
        if (authStatus) {
          const userInfo = await fetchUserInfo();
          await user.setUser(userInfo);
          await user.setIsAuth(true);
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error("Auth verification error:", error);
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };
    verifyAuth();
  }, [user, isLocalProfilePreview]);

  if (isLoading) {
    return <MyBigSpinner />;
  }

  if (!isAuthenticated && location.pathname === REGISTER_ROUTE_WITH_REF) {
    return <Outlet />;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to={ACCOUNT_ROUTE} replace />;
};

const AppRoutes: FC = () => {
  return (
    <ScrollToTop>
      <Routes>
        {publicRoutes.map(({ path, Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
        <Route element={<ProtectedRoute />}>
          {authRoutes.map(({ path, Component }) => (
            <Route key={path} path={path} element={<Component />} />
          ))}
        </Route>
        <Route path="*" element={<Navigate to={ACCOUNT_ROUTE} replace />} />
      </Routes>
    </ScrollToTop>
  );
};

export default observer(AppRoutes);
